import { createContext } from "react";

const BI_AUT003Context = createContext();

export { BI_AUT003Context };
